import { render } from "./CreatedImageView.vue?vue&type=template&id=df3efc56&scoped=true"
import script from "./CreatedImageView.vue?vue&type=script&lang=js"
export * from "./CreatedImageView.vue?vue&type=script&lang=js"

import "./CreatedImageView.vue?vue&type=style&index=0&id=df3efc56&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df3efc56"]])

export default __exports__